import { Dialog } from "@headlessui/react";
import { useNavigate } from "react-router-dom";
import { WhiteLinearGradient } from "../../utils/Utils";
import ic_close from "../../assets/icons/ic_close.svg";
import Button from "../basic/Button";
import CustomDialog from "../basic/Dialog";
import IconButton from "../basic/IconButton";

function PlanExpiredDialog({ show, close }) {
  const navigate = useNavigate();
  return (
    <CustomDialog show={show} close={close}>
      <Dialog.Panel>
        <div
          className={`flex flex-col max-w-3xl ${WhiteLinearGradient} rounded-xl w-full p-10 `}
        >
          <div className="w-full flex justify-end items-end">
            <IconButton
              icon={ic_close}
              className="shadow-xl flex justify-end"
              onClick={close}
            />
          </div>
          <p className="text-primary-orange font-bold text-xl ">
            Your Plan has expired
          </p>
          <p className="text-primary-lightBlack font-medium mt-3 text-xl ">
            {" "}
            Subscribe now to continue using Getactyv
          </p>
          <Button
            type="primary"
            className={"mt-10"}
            onClick={() => {
              navigate("/subscription");
            }}
          >
            Subscribe Now
          </Button>
        </div>
      </Dialog.Panel>
    </CustomDialog>
  );
}

export default PlanExpiredDialog;
